import apiClient, { storage } from '../client';
import type { LoginRequest, LoginResponse, RegisterRequest } from '../../types';

const authService = {
  login: async (credentials: LoginRequest) => {
    const response = await apiClient.post<LoginResponse>('/auth/login', credentials);
    const { token, ...userData } = response.data;
    await storage.setItem('jwt_token', token);
    await storage.setItem('user_data', JSON.stringify(userData));
    return response.data;
  },

  register: async (data: RegisterRequest) => {
    const response = await apiClient.post<LoginResponse>('/auth/register', data);
    const { token, ...userData } = response.data;
    await storage.setItem('jwt_token', token);
    await storage.setItem('user_data', JSON.stringify(userData));
    return response.data;
  },

  logout: async () => {
    await storage.removeItem('jwt_token');
    await storage.removeItem('user_data');
  },

  isAuthenticated: async () => {
    const token = await storage.getItem('jwt_token');
    return !!token;
  },

  getCurrentUser: async () => {
    const userData = await storage.getItem('user_data');
    return userData ? JSON.parse(userData) : null;
  },
};

export default authService;
